import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isSourceAndAttributes = function isSourceAndAttributes(x) {
  if (_typeof(x) !== 'object' || x === null) {
    return false;
  }
  if (!('source' in x) || !('attributes' in x) || _typeof(x.attributes) !== 'object' || x.attributes === null) {
    return false;
  }
  return true;
};

/**
 * Extracts the attributes from the relevant AIMate contexts.
 * Contexts is an array of (any) object - to determine which objects we want to extract the attributes from,
 * we add a source of 'AIMate' to the object.
 */
export var getAttributesFromContexts = function getAttributesFromContexts(context) {
  if (!context || !Array.isArray(context)) {
    return {};
  }
  var aiMateOnly = context.filter(function (x) {
    return isSourceAndAttributes(x) && x.source === 'AIMate';
  });
  return aiMateOnly.reduce(function (acc, x) {
    var _x$attributes;
    return _objectSpread(_objectSpread({}, acc), (_x$attributes = x.attributes) !== null && _x$attributes !== void 0 ? _x$attributes : {});
  }, {});
};